<template>
  <div class="content">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:left;margin-top:5px;">Banners</span>
    </div>
    <div class="line">
      <button @click="openBanner(null, 'home_carousel_slider')" style="float:right;">Novo Banner</button>
      <div style="padding:10px; ">
        <h3>Carrosel da Página "Home"</h3>
        <table border="1" cellpadding="5px" style="min-width:700px; border-collapse:collapse; border:1px solid #706C7A;">
          <thead>
          <tr>
            <td style="text-align:left;" colspan="2">Tamanho</td>
            <td style="text-align:left;">Imagem</td>
            <td>Link de redirecionamento</td>
            <td>Ordem</td>
            <td>Ações</td>
          </tr>
          </thead>
          <tbody>
          <template v-for="(banner, idx) in homeCarouselSlider">
            <tr v-bind:key="idx + '_0'">
              <td>450x300</td>
              <td>
                <label v-if="banner.xs_url" :for="'selecao-arquivo1_' + idx">alterar imagem</label>
                <label v-else :for="'selecao-arquivo1_' + idx">adicionar imagem</label>
                <input :id="'selecao-arquivo1_' + idx" @change="saveImage($event, banner, 'xs_url')" type="file"/>
              </td>
              <td style="width:400px;">
                <img v-if="banner.xs_url" :src="getImage(banner, 'xs_url')" style="max-width:400px;">
              </td>
              <td rowspan="3" style="border-bottom: 3px solid #706C7A;text-align:center;">
                <div @click="openBanner(banner)" style="text-decoration:underline;cursor:pointer;">{{banner.call_to_action ? banner.call_to_action : banner.external_link || 'Escolher link de redirecionamento'}}</div>
              </td>
              <td style="text-align:right;border-bottom: 3px solid #706C7A;width:80px;" rowspan="3">
                <OpaContentEditable type="number" decimal="0" inputWidth="32px" v-model="banner.order" @click="(e) => updateBannerOrder(banner,e)"/>
              </td>
              <td rowspan="3" style="border-bottom: 3px solid #706C7A;">
                <div @click="removeBanner(banner)">
                  <OpaIcon name="remove" alt="Excluir" color="red" style="cursor:pointer;margin:6px;"/>
                </div>
              </td>
            </tr>
            <tr v-bind:key="idx + '_1'">
              <td>900x400</td>
              <td>
                <label v-if="banner.sm_url" :for="'selecao-arquivo2_' + idx">alterar imagem</label>
                <label v-else :for="'selecao-arquivo2_' + idx">adicionar imagem</label>
                <input :id="'selecao-arquivo2_' + idx" @change="saveImage($event, banner, 'sm_url')" type="file"/>
              </td>
              <td><img v-if="banner.sm_url" :src="getImage(banner, 'sm_url')" style="max-width:300px;"></td>
            </tr>
            <tr v-bind:key="idx + '_2'">
              <td style="border-bottom: 3px solid #706C7A;">1330x500</td>
              <td style="border-bottom: 3px solid #706C7A;">
                <label v-if="banner.md_url" :for="'selecao-arquivo3_' + idx">alterar imagem</label>
                <label v-else :for="'selecao-arquivo3_' + idx">adicionar imagem</label>
                <input :id="'selecao-arquivo3_' + idx" @change="saveImage($event, banner, 'md_url')" type="file"/>
              </td>
              <td style="border-bottom: 3px solid #706C7A;"><img v-if="banner.md_url" :src="getImage(banner, 'md_url')" style="max-width:300px;"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="line">
      <button v-if="!$store.state.company.out_of_range_banner" @click="openBanner(null, 'out_of_range')" style="float:right;">Novo Banner</button>
      <div style="padding:10px; ">
        <h3>Endereço do Cliente não é atendido</h3>
        <table border="1" cellpadding="5px"
               style="min-width:700px; border-collapse:collapse; border:1px solid #706C7A;">
          <thead>
          <tr>
            <td style="text-align:left;" colspan="2">Tamanho</td>
            <td style="text-align:left;">Imagem</td>
            <td>Link de redirecionamento</td>
            <td>Ações</td>
          </tr>
          </thead>
          <tbody>
          <template v-if="$store.state.company.out_of_range_banner">
            <tr>
              <td>450x300</td>
              <td>
                <label v-if="$store.state.company.out_of_range_banner.xs_url" for="out_of_range_1">alterar imagem</label>
                <label v-else for="out_of_range_1">adicionar imagem</label>
                <input id="out_of_range_1" @change="saveImage($event, $store.state.company.out_of_range_banner, 'xs_url')" type="file"/>
              </td>
              <td style="width:400px;">
                <img v-if="$store.state.company.out_of_range_banner.xs_url" :src="getImage($store.state.company.out_of_range_banner, 'xs_url')" style="max-width:400px;">
              </td>
              <td rowspan="3" style="border-bottom: 3px solid #706C7A;text-align:center;">
                <div @click="openBanner($store.state.company.out_of_range_banner, 'out_of_range')" style="text-decoration:underline;cursor:pointer;">{{this.$store.state.company.out_of_range_banner.call_to_action ? this.$store.state.company.out_of_range_banner.call_to_action : this.$store.state.company.out_of_range_banner.external_link || 'Escolher link de redirecionamento'}}
                </div>
              </td>
              <td rowspan="3" style="border-bottom: 3px solid #706C7A;">
                <div @click="removeBanner($store.state.company.out_of_range_banner)">
                  <OpaIcon name="remove" alt="Excluir" color="red" style="cursor:pointer;margin:6px;"/>
                </div>
              </td>
            </tr>
            <tr>
              <td>900x400</td>
              <td>
                <label v-if="$store.state.company.out_of_range_banner.sm_url" for="out_of_range_2">alterar imagem</label>
                <label v-else for="out_of_range_2">adicionar imagem</label>
                <input id="out_of_range_2" @change="saveImage($event, $store.state.company.out_of_range_banner, 'sm_url')" type="file"/>
              </td>
              <td><img v-if="$store.state.company.out_of_range_banner.sm_url" :src="getImage($store.state.company.out_of_range_banner, 'sm_url')" style="max-width:300px;"></td>
            </tr>
            <tr>
              <td style="border-bottom: 3px solid #706C7A;">1330x500</td>
              <td style="border-bottom: 3px solid #706C7A;">
                <label v-if="$store.state.company.out_of_range_banner.md_url" for="out_of_range_3">alterar imagem</label>
                <label v-else for="out_of_range_3">adicionar imagem</label>
                <input id="out_of_range_3" @click="saveImage($event, $store.state.company.out_of_range_banner, 'md_url')" type="file"/>
              </td>
              <td style="border-bottom: 3px solid #706C7A;"><img v-if="$store.state.company.out_of_range_banner.md_url" :src="getImage($store.state.company.out_of_range_banner, 'md_url')" style="max-width:300px;"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="line" v-if="iamParent()">
      <button v-if="!$store.state.company.hero_banner" @click="openBanner(null, 'hero_banner')" style="float:right;">Novo Hero Banner</button>
      <div style="padding:10px; ">
        <h3>Banner Superior - Categorias de Estabelecimentos (Exclusivo para Marketplaces)</h3>
        <table border="1" cellpadding="5px"
               style="min-width:700px; border-collapse:collapse; border:1px solid #706C7A;">
          <thead>
          <tr>
            <td style="text-align:left;" colspan="2">Imagem</td>
            <td>Link de redirecionamento</td>
            <td>Ações</td>
          </tr>
          </thead>
          <tbody>
          <template v-if="$store.state.company.hero_banner">
            <tr>
              <td>
                <label v-if="$store.state.company.hero_banner.image">alterar imagem</label>
                <input @change="saveImage($event, $store.state.company.hero_banner, 'hero_banner')" type="file"/>
              </td>
              <td style="width:400px;">
                <img v-if="$store.state.company.hero_banner.image" :src="getImage($store.state.company.hero_banner)" style="max-width:400px;">
              </td>
              <td rowspan="3" style="border-bottom: 3px solid #706C7A;text-align:center;">
                <div @click="openBanner($store.state.company.hero_banner, 'hero_banner')" style="text-decoration:underline;cursor:pointer;">{{this.$store.state.company.hero_banner.link ? this.$store.state.company.hero_banner.link : 'Escolher link de redirecionamento'}}
                </div>
              </td>
              <td rowspan="3" style="border-bottom: 3px solid #706C7A;">
                <div @click="removeBanner($store.state.company.hero_banner)">
                  <OpaIcon name="remove" alt="Excluir" color="red" style="cursor:pointer;margin:6px;"/>
                </div>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <OpaImg v-model="modalBanner" :inputBanner="tempBanner" @saveBanner="currentBanner => saveEventHandler(currentBanner)" @close="modalBanner=false"></OpaImg>
    <OpaHeroBanner v-model="modalHeroBanner" :inputBanner="tempHeroBanner" @saveHeroBanner="currentHeroBanner => saveEventHandler(currentHeroBanner)" @close="modalHeroBanner=false"></OpaHeroBanner>
  </div>
</template>

<script>
  import OpaIcon from '@/components/OpaIcon.vue'
  import OpaImg from '@/components/OpaImg.vue'
  import OpaHeroBanner from '@/components/OpaHeroBanner.vue'
  import {EventBus} from '@/utils/event-bus'
  import axios from 'axios'
  import {mapGetters} from 'vuex'
  import OpaContentEditable from '@/components/OpaContentEditable.vue'

  export default {
    name: 'Banners',
    data() {
      return {
        modalBanner: false,
        tempBanner: {
          id: null,
          order: 0,
          call_to_action: null,
          xs_url: null,
          sm_url: null,
          md_url: null
        },
        modalHeroBanner: false,
        tempHeroBanner: {
          id: null,
          image: null,
          link: null,
        }
      }
    },

    components: {
      OpaIcon,
      OpaContentEditable,
      OpaImg,
      OpaHeroBanner
    },

    computed: {
      ...mapGetters(['getOpaApi']),
      homeCarouselSlider() {
        return this.getCompany().banners
      }
    },

    methods: {
      ...mapGetters(['getAdmin', 'getCompany']),

      iamParent() {
        return this.$store.state.company.parent_company_id ? false : true
      },

      getImage(banner, size) {
        if (banner.type == 'hero_banner' && banner.id) {
          return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/banner/' + banner.image
        }
        else {
          return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/banner/' + banner[size]
        }
      },

      saveImage(e, banner, size) {
        let vm = this
        if (e.target.value) {
          let bodyFormData = new FormData()
          bodyFormData.append('file', e.target.files[0])
          EventBus.$emit('showLoading', true)
          axios({
            method: 'post',
            url: this.getOpaApi + '/files/company/' + this.getCompany().companyId + '/banner',
            data: bodyFormData,
            config: {headers: {'Content-Type': 'form-data'}}
          })
            .then(function (response) {
              console.log('banner file', response.data)
              size == 'hero_banner' ? banner = response.data.file_name : banner[size] = response.data.file_name
              vm.updateBannerData(banner)
            })
            .catch(function (response) {
              console.log(response)
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'error', 'erro ao subir imagem')
            })
        }
      },

      saveEventHandler(currentBanner) {
        if(currentBanner.type !== 'hero_banner'){
          if (currentBanner.typeLink === 'Product' || currentBanner.typeLink === 'Category' || currentBanner.typeLink === 'Page') {
            currentBanner.external_link = null
          } else if (currentBanner.typeLink === 'External') {
            currentBanner.call_to_action = null
          }
        }
        if (currentBanner.id) {
          this.updateBannerData(currentBanner)
        } else {
          this.saveNewBanner(currentBanner)
          }
      },

      openBanner(banner, type) {
         if (!banner && type == 'hero_banner'){
          this.modalHeroBanner = true
          this.tempHeroBanner = {
            id: null,
            link: null,
            type: type
          }
          return
        } if (!banner) {
          this.modalBanner = true
          this.tempBanner = {
            id: null,
            order: 0,
            call_to_action: null,
            external_link: null,
            xs_url: null,
            sm_url: null,
            md_url: null,
            type: type
          }
          return
        } if (banner && type == 'hero_banner'){
          this.modalHeroBanner = true
          this.tempHeroBanner = {
            id: banner.id,
            link: banner.link,
            image: banner.image,
            type: type
          }
          return
        } else {
          this.modalBanner = true
          this.tempBanner = {
            id: banner.id,
            order: banner.order,
            call_to_action: banner.call_to_action,
            external_link: banner.external_link,
            xs_url: banner.xs_url,
            sm_url: banner.sm_url,
            md_url: banner.md_url,
            type: type
          }
          return
        }
      },

      updateBannerData(banner) {
        let vm = this
        EventBus.$emit('showLoading', true)
        if (banner.external_link) banner.external_link = this.httpChecker(banner.external_link)
        if (banner.link) banner.link = this.httpChecker(banner.link)
        axios.put(this.getOpaApi + '/company/banner/' + this.getCompany().Id, banner)
          .then((response) => {
            vm.$store.commit('setCompany', response.data)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'banner atualizado')
            banner.type === 'hero_banner' ? this.modalHeroBanner = false : this.modalBanner = false
          })
          .catch((e) => {
            console.log('ERROR', e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao atualizar banner')
          })
      },

      updateBannerOrder(banner, newOrder) {
        banner.order = Number(newOrder)
        EventBus.$emit('showLoading', true)
        this.updateBannerData(banner)
      },

      httpChecker(bannerExternalLink) {
        if (!(bannerExternalLink.toLowerCase().startsWith('http://') || bannerExternalLink.toLowerCase().startsWith('https://'))) {
          bannerExternalLink = 'http://' + bannerExternalLink
        }
        return bannerExternalLink
      },

      saveNewBanner(currentBanner) {
        let vm = this
        if (currentBanner.external_link) currentBanner.external_link = this.httpChecker(currentBanner.external_link)
        if (currentBanner.link) currentBanner.link = this.httpChecker(currentBanner.link)
        EventBus.$emit('showLoading', true)
        axios.post(this.getOpaApi + '/company/banner/' + this.getCompany().Id, currentBanner)
          .then((response) => {
            vm.$store.commit('setCompany', response.data)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'banner salvo')
            currentBanner.type === 'hero_banner' ? this.modalHeroBanner = false : this.modalBanner = false
          })
          .catch((e) => {
            console.log('ERROR', e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao salvar banner')
          })
      },

      removeBanner(banner) {
        if (confirm('Tem certeza que deseja remover o banner?')) {
          EventBus.$emit('showLoading', true)
          let vm = this
          axios.delete(this.getOpaApi + '/company/banner/' + this.getCompany().Id + '/' + banner.id)
            .then((r) => {
              vm.$store.commit('setCompany', r.data)
              banner.image ? vm.hero_banner = this.getCompany().hero_banner : vm.banners = this.getCompany().banners
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'success', 'Banner removido')
            })
            .catch((e) => {
              console.log(e)
              EventBus.$emit('showLoading', false)
              EventBus.$emit('showAlert', 'error', 'erro ao deletar banner')
            })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  input[type='file'] {
    display: none;
  }

  label {
    cursor: pointer;
    text-decoration: underline;
  }
</style>
